import React from 'react'

export const StudentLearn = () => {
  return (
    <div>StudentLearn</div>
  )
}
